<div class="container">

  <tgrid-page-header></tgrid-page-header>

  <div class="map-section">
    <div class="section-header">
      <vulcan-icon size="42px" icon="globe-hemisphere-west" weight="fill"></vulcan-icon>
      <h2>Maps</h2>
    </div>

    <div class="section-subtitle">
      The TASTI-GRID mapper allows users to overlay Climate and Economic data with critical infrastructure, historical
      power outage data, and other geospatial components related to economic impact. Check out one of the featured maps
      below or view the <a routerLink="map" class="page-link">Main Maps page</a>
    </div>

    <div class="section-content">
      <div class="bg-image"></div>
      <div class="content-info">
        <span>Quick Start</span>

        <div class="info-card-container">
          @for (layer of mapLayers; track $index) {
            <div class="info-card">
              <vulcan-icon size="32px" icon="map-pin"></vulcan-icon>
              <span>{{ layer.title }}</span>
              <p>{{ layer.description }}</p>
              <button mat-flat-button color="primary" [routerLink]="layer.link">
                View Map
              </button>
            </div>
          }
        </div>
      </div>
    </div>


  </div>

  <div class="report-section">
    <div class="section-header">
      <vulcan-icon size="42px" icon="folders" weight="fill"></vulcan-icon>
      <h2>Reports</h2>
    </div>
    <div class="section-subtitle">
      The TASTI-GRID reports feature a granular view of <b>power outages over time</b>, power outages related to
      weather, and
      power restoration trends by individual counties. Run one of the <b>featured reports below</b> or view the
      <a routerLink="reports" class="page-link">Main reports page</a>
    </div>
    <div class="section-content">
      <div class="bg-image"></div>
      <div class="content-info">
        <span>Quick Start</span>

        <div class="info-card-container">
          @for (report of reports; track $index) {
            <div class="info-card">
              <vulcan-icon size="32px" icon="folder"></vulcan-icon>
              <span>{{ report.title }}</span>
              <p >{{ report.description }}</p>
              <button mat-flat-button color="primary" [routerLink]="report.link">
                Run Report
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  <tgrid-page-footer></tgrid-page-footer>

</div>

